import { Box } from '@/common/components/base-app';
import { styled } from '@/stitches.config';

export const StyledDateRangeDropdownContainer = styled(Box, {
  display: 'flex',
  alignItems: 'center',
});
